import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { format } from 'date-fns';

interface EmspBoTariffCreatedBeforeFilterStateControllerProps {
  value: Date | string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoTariffCreatedBeforeFilterStateController = ({
  value,
  onRemove,
}: EmspBoTariffCreatedBeforeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const createdAt = format(value, 'yyyy-MM-dd');

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="calendar-date" label={createdAt} onRemove={onRemove} />
  );
};
